import { render, staticRenderFns } from "./ScaleDropDownSelector.vue?vue&type=template&id=06bf652c&scoped=true&"
import script from "./ScaleDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./ScaleDropDownSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf652c",
  null
  
)

export default component.exports